/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DMapTileMapping } from "./d-map-tile-mapping";

export interface DDiagramCanvasTileMapping extends DMapTileMapping {
	enable: boolean;
}
